<script>
import VisitLocationsService from '@/services/VisitLocationsService';
import { mapState } from 'vuex';
import VisitLocationModal from '@/views/visitLocations/modals/VisitLocationModal.vue';

export default {
  name: 'VisitLocations',
  components: { VisitLocationModal },
  data() {
    return {
      loading: true,
      visitLocations: [],
      fields: [
        { label: 'Name', key: 'name', thStyle: { width: '50%' } },
        { label: 'Table Count', key: 'social_table_count', thStyle: { width: '40%' } },
        { label: 'Actions', key: 'actions', thStyle: { width: '10%' } },
      ],
      visitLocationModalId: 'modal-id',
      selectedLocation: null,
    };
  },
  computed: {
    ...mapState({
      prison: state => state.prison.prison,
    }),
  },
  mounted() {
    try {
      this.getVisitLocations();
      this.loading = false;
    } catch (e) {
      this.$router.go(-1);
    }
  },
  methods: {
    async getVisitLocations() {
      try {
        if (!this.prison) {
          await this.$store.dispatch('prison/getPrison');
        }
        const response = await VisitLocationsService.getVisitLocationsForPrison();
        this.visitLocations = response.data;
      } catch (e) {
        console.error('Error getting visit locations: ', e);
        this.$toast.error('Error getting visit locations. Please refresh and try again.', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
        throw e;
      }
    },
    async deleteLocation(location) {
      try {
        const proceed = await this.$swal({
          title: 'Are you sure?',
          text: 'Are you sure you want to delete this location?',
          icon: 'warning',
          buttons: true,
          dangerMode: true,
        });
        if (!proceed) return;
        await VisitLocationsService.deleteVisitLocation(location._id);
        this.getVisitLocations().then();
        this.$toast.success('Visit location removed.', {
          toastClassName: ['toast-std', 'success-toast'],
        });
      } catch (e) {
        console.error('Error deleting visit location: ', e);
        this.$toast.error('Error deleting visit location. Please try again.', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }
    },
    createLocation() {
      this.selectedLocation = null;
      this.$bvModal.show(this.visitLocationModalId);
    },
    editLocation(location) {
      this.selectedLocation = location;
      this.$bvModal.show(this.visitLocationModalId);
    },
    closeModal() {
      this.selectedLocation = null;
      this.$bvModal.hide(this.visitLocationModalId);
    },
    refresh() {
      this.closeModal();
      this.getVisitLocations();
    },
  },
}
</script>

<template>
  <div v-if="loading">
    <div class="col text-center mt-5">
      <span class="fas fa-spinner fa-spin" style="font-size: 2em;" />
    </div>
  </div>
  <div v-else>
    <b-card no-body>
      <b-row class="p-2">
        <b-col>
          <b-btn class="float-right" variant="primary" @click="createLocation">
            Create Location
          </b-btn>
          <h2>Visit Locations</h2>
        </b-col>
      </b-row>
      <b-table
        :fields="fields"
        :items="visitLocations"
        class="mb-0"
        hover
        responsive
        show-empty
      >
        <template #cell(social_table_count)="data">
          {{ data.item.social_table_count ? data.item.social_table_count : 'N/A' }}
        </template>
        <template #cell(actions)="data">
          <b-dropdown class="m-0" variant="link" right toggle-class="text-decoration-none" no-caret>
            <template #button-content>
              <i class="fas fa-ellipsis-v" />
            </template>
            <b-dropdown-item-button
              class="full-nested-btn"
              @click="editLocation(data.item)"
            >
              Edit
            </b-dropdown-item-button>
            <b-dropdown-item-button
              class="full-nested-btn"
              @click="deleteLocation(data.item)"
            >
              Remove
            </b-dropdown-item-button>
          </b-dropdown>
        </template>
      </b-table>
    </b-card>

    <b-modal
      :id="visitLocationModalId"
      hide-footer
    >
      <visit-location-modal
        :existing="selectedLocation"
        @close="closeModal"
        @refresh="refresh"
      />
    </b-modal>
  </div>
</template>
